(function () {
  var SECTION = '.oddit-section-editorial-numbered';
  var CAROUSEL = '.oddit-section-editorial-numbered__carousel';
  var INDICATOR = '.oddit-section-editorial-numbered__progress-indicator';
  var CARD = '.oddit-section-editorial-numbered__card';

  function updateNav(carousel) {
    var wrap = carousel.parentNode;
    var navs = wrap.querySelectorAll('[data-carousel-nav]');
    if (!navs.length) return;
    var overflow = carousel.scrollWidth - carousel.clientWidth;
    var image = carousel.querySelector('.oddit-section-editorial-numbered__card-image');
    navs.forEach(function (nav) {
      var dir = Number(nav.dataset.carouselNav);
      nav.hidden = overflow <= 1 || (dir < 0 ? carousel.scrollLeft <= 1 : carousel.scrollLeft >= overflow - 1);
      if (image) nav.style.top = image.offsetTop + image.offsetHeight / 2 + 'px';
    });
  }

  function bindNav(carousel) {
    carousel.parentNode.querySelectorAll('[data-carousel-nav]').forEach(function (nav) {
      if (nav._odditNavBound) return;
      nav._odditNavBound = true;
      nav.addEventListener('click', function () {
        var card = carousel.querySelector(CARD);
        var gap = parseFloat(getComputedStyle(carousel).columnGap) || 0;
        var step = card ? card.offsetWidth + gap : carousel.clientWidth;
        carousel.scrollBy({ left: step * Number(nav.dataset.carouselNav), behavior: 'smooth' });
      });
    });
  }

  function updateProgress(carousel) {
    updateNav(carousel);
    var indicator = carousel
      .closest('.oddit-section-editorial-numbered__item')
      .querySelector(INDICATOR);
    if (!indicator) return;
    var progress = indicator.parentNode;

    var maxScroll = carousel.scrollWidth - carousel.clientWidth;
    if (maxScroll <= 1) {
      progress.style.display = 'none';
      return;
    }
    progress.style.display = '';
    var visible = carousel.clientWidth / carousel.scrollWidth;
    indicator.style.width = visible * 100 + '%';
    indicator.style.left = (carousel.scrollLeft / maxScroll) * (100 - visible * 100) + '%';
  }

  function initSection(section) {
    if (!section) return;

    var carousels = section.querySelectorAll(CAROUSEL);
    carousels.forEach(function (carousel) {
      bindNav(carousel);
      updateProgress(carousel);
      if (carousel._odditScrollHandler) return;

      var handler = function () { updateProgress(carousel); };
      carousel.addEventListener('scroll', handler, { passive: true });
      carousel._odditScrollHandler = handler;
      if (window.ResizeObserver) {
        carousel._odditResizeObserver = new ResizeObserver(handler);
        carousel._odditResizeObserver.observe(carousel);
      }
    });
  }

  function destroySection(section) {
    if (!section) return;

    var carousels = section.querySelectorAll(CAROUSEL);
    carousels.forEach(function (carousel) {
      if (carousel._odditScrollHandler) {
        carousel.removeEventListener('scroll', carousel._odditScrollHandler);
        delete carousel._odditScrollHandler;
      }
      if (carousel._odditResizeObserver) {
        carousel._odditResizeObserver.disconnect();
        delete carousel._odditResizeObserver;
      }
    });
  }

  function init() {
    document.querySelectorAll(SECTION).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION);
    initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION);
    destroySection(section);
  });
})();